var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-input-group",
    { attrs: { prepend: _vm.currencySymbol } },
    [
      _c("b-input", {
        ref: "inputRef",
        attrs: {
          name: _vm.name,
          placeholder: _vm.placeholder,
          state: _vm.invalid
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }